import { useState, useEffect } from "react";
import { PopupDialog } from "../../components/popupDialog";
import "../../assets/css/components.css";
import { Preview } from "../../components/preview";

export const MediaPreview = ({
  isPreviewOpen = false,
  handlePreviewClose,
  content = "",
  type = "",
}) => {
  const [imageULRs, setImageURLs] = useState([]);
  useEffect(() => {
    setImageURLs(content);
  }, [content]);

  return (
    <PopupDialog
      name="mediaPreview"
      open={isPreviewOpen}
      onClose={() => {
        handlePreviewClose();
      }}
      neutralAction={handlePreviewClose}
      content={<Preview currentList={imageULRs} type={type} />}
    />
  );
};
